import { __assign, __rest, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Button, IconButton, Stack, TextField, Typography, Avatar, } from "@mui/material";
import { EditOutlined, RemoveCircleOutline } from "@mui/icons-material";
import * as yup from "yup";
import uniqBy from "lodash/uniqBy";
import findIndex from "lodash/findIndex";
import { FieldControl, } from "@pangeacyber/react-mui-shared";
var UnControlledSharePasswordField = function (_a) {
    var _b = _a.onValueChange, onValueChange = _b === void 0 ? function () { } : _b, props = __rest(_a, ["onValueChange"]);
    var value = useMemo(function () {
        var value = props.value || props.default || [];
        return uniqBy(value, "email");
    }, [props.value, props.default]);
    var _c = useState(""), emailValue = _c[0], setEmailValue = _c[1];
    var _d = useState(undefined), emailError = _d[0], setEmailError = _d[1];
    var _e = useState(undefined), editRow = _e[0], setEditRow = _e[1];
    var minHeight = !(value === null || value === void 0 ? void 0 : value.length)
        ? "0"
        : value.length >= 3
            ? "148px"
            : "".concat(value.length * 48, "px");
    var validate = function () {
        yup
            .string()
            .required("Email is a required field")
            .email("A valid email is required")
            .isValid(emailValue)
            .then(function (isValid) {
            if (!isValid)
                setEmailError("Must be a valid email address");
            else
                setEmailError(undefined);
        });
    };
    useEffect(function () {
        if (emailValue === "") {
            setEmailError(undefined);
            setEditRow(undefined);
            return;
        }
        validate();
    }, [emailValue]);
    var handleAddOption = function () {
        if (!emailValue || !!emailError)
            return;
        var value_ = __spreadArray([], value, true);
        if (editRow === undefined) {
            value_.push({
                phone_number: "",
                email: emailValue,
            });
        }
        else {
            var update = __assign(__assign({}, value_[editRow]), { email: emailValue });
            value_[editRow] = update;
        }
        value_ = uniqBy(value_, "email");
        onValueChange(value_);
        setEmailValue("");
        setEditRow(undefined);
    };
    var handleRemoveOption = function (recipient) {
        var idx = findIndex(value, function (v) { return v.email === recipient.email; });
        if (idx === -1)
            return;
        var value_ = value.slice(0, idx).concat(value.slice(idx + 1));
        onValueChange(value_);
    };
    var handleEditOption = function (recipient) {
        var idx = findIndex(value, function (v) { return v.email === recipient.email; });
        if (idx === -1)
            return;
        setEditRow(idx);
        setEmailValue(recipient.email);
    };
    return (_jsxs(Stack, { gap: 1, width: "100%", children: [_jsxs(Stack, { width: "100%", direction: "row", mt: 1, gap: 0.5, alignItems: "flex-start", children: [_jsx(TextField, { value: emailValue, name: "recipient_email", label: "Add email", onChange: function (e) {
                            var value = e.target.value;
                            setEmailValue(value);
                            e.stopPropagation();
                        }, error: !!emailError, helperText: emailError, onKeyDown: function (event) { return event.stopPropagation(); }, autoComplete: "off", fullWidth: true, onBlur: handleAddOption, onKeyUp: function (event) {
                            if (event.key === "Enter") {
                                handleAddOption();
                                event.preventDefault();
                            }
                        }, size: "small", sx: {
                            "& .MuiFormHelperText-sizeSmall": {
                                marginLeft: 1,
                            },
                        } }), _jsx(Button, { variant: "outlined", title: "Add recipient", onClick: handleAddOption, sx: { minWidth: "100px" }, children: editRow === undefined ? "Add" : "Update" })] }), _jsx(Stack, { direction: "row", alignItems: "flex-start", gap: 1, mb: 1, sx: {
                    flexWrap: "wrap",
                    overflow: "hidden",
                    overflowY: "auto",
                    minHeight: minHeight,
                    maxHeight: "calc(100vh - 600px)",
                }, children: value.map(function (recipient, idx) {
                    return (_jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", width: "100%", children: [_jsxs(Stack, { direction: "row", gap: 1, alignItems: "center", children: [_jsx(Avatar, { children: recipient.email.charAt(0).toLocaleUpperCase() }), _jsx(Typography, { variant: "body2", children: recipient.email })] }), _jsxs(Stack, { direction: "row", children: [_jsx(IconButton, { onClick: function () { return handleEditOption(recipient); }, children: _jsx(EditOutlined, { fontSize: "small" }) }), _jsx(IconButton, { onClick: function () { return handleRemoveOption(recipient); }, children: _jsx(RemoveCircleOutline, { fontSize: "small" }) })] })] }, "email-".concat(idx, "-").concat(recipient.email)));
                }) })] }));
};
var SharePasswordField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledSharePasswordField, __assign({}, props)) })));
};
export default SharePasswordField;
